export enum ExportComponents {
    SIT_REP_MAP = 'eaglei-sit-rep-map',
    SIT_REP_TABLE = 'eaglei-sit-rep-table',
    SIT_REP_METRIC = 'eaglei-sit-rep-metric',
    NOM_CHART = 'eaglei-nom-chart',
}
